// extracted by mini-css-extract-plugin
export var copyableField = "_kt-4";
export var customerBadge = "_kt-0";
export var customerInfoTitle = "_kt-2";
export var details = "_kt-1";
export var dropdownContainer = "_kt-5";
export var dropdownImage = "_kt-6";
export var editAssigneeForm = "_kt-a";
export var editButton = "_kt-3";
export var email = "_kt-7";
export var hidden = "_kt-d";
export var input = "_kt-8";
export var saveButton = "_kt-b";
export var shopifyIcon = "_kt-c";
export var suggestionBadge = "_kt-e";
export var suggestionText = "_kt-f";
export var username = "_kt-9";